import { SERVER_ORIGIN, StoreName } from "constants/serviceWorker";
import CustomResponseInspectionContent from "./CustomResponseInspectionContent";
import CustomResponseInspectionPin from "./CustomResponseInspectionPin";
import CustomResponseInspectionType from "./CustomResponseInspectionType";
import CustomResponseTaskType from "./CustomResponseTaskType";
import CustomResponseTaskComment from "./CustomResponseTaskComment";
import CustomResponseDataLog from "./CustomResponseDataLog";
import CustomResponseDocumentTask from "./CustomResponseDocumentTask";
import BaseCustomGetResponse from "./BaseCustomGetResponse";
import { BaseCustomResponseParams } from "../../BaseCustomResponse";
import CustomResponseAps from "./CustomResponseAps";
import CustomDefaultGetResponse from "./CustomDefaultGetResponse";
import CustomAutoDeskResponse from "./CustomResponseAutoDesk";
import CustomResponseS3 from "./CustomResponseS3";
import CustomResponseImage from "./CustomResponseImage";
import { API_S3_IMAGES } from "constants/default";

const MapStoreWithCustomRequest = {
  [StoreName.INSPECTION_PIN]: CustomResponseInspectionPin,

  [StoreName.INSPECTION_CONTENT]: CustomResponseInspectionContent,
  [StoreName.INSPECTION_ITEM]: CustomResponseInspectionContent,
  [StoreName.INSPECTION_ITEM_RESULT]: CustomResponseInspectionContent,

  [StoreName.INSPECTION_TYPE]: CustomResponseInspectionType,
  [StoreName.DOCUMENT_TASKS]: CustomResponseDocumentTask,
  [StoreName.TASK_TYPES]: CustomResponseTaskType,
  [StoreName.TASK_COMMENTS]: CustomResponseTaskComment,
  [StoreName.DATA_LOGS]: CustomResponseDataLog,
};

export default class FactoryCustomGetResponse {
  static getResponseHandler(params: BaseCustomResponseParams) {
    const { event } = params;
    const url = event.request.url;

    if (url.startsWith(process.env.REACT_APP_S3_URL!)) {
      return new CustomResponseS3(params);
    }

    if (url.includes(API_S3_IMAGES)) {
      return new CustomResponseImage(params);
    }

    if (url.includes("autodesk.com")) {
      return new CustomAutoDeskResponse(params);
    }

    if (url.includes("/aps")) {
      return new CustomResponseAps(params);
    }

    if (url.includes(SERVER_ORIGIN)) {
      const storeName = params.storeNameOfRequest;
      const CustomResponseHandler =
        MapStoreWithCustomRequest[
          storeName as keyof typeof MapStoreWithCustomRequest
        ] || BaseCustomGetResponse;

      return new CustomResponseHandler(params);
    }

    return new CustomDefaultGetResponse(params);
  }
}
